import type { MailboxInfo } from "owa-client-types";
import { isOcpsPolicyEnabled, OcpsPolicy } from "owa-ocps-policy-store";
import { LoopType } from "./constants";

export function isOCPSPolicyEnabledForLoopType(loopType: LoopType, mailboxInfo: MailboxInfo): boolean {
    let ocpsPolicyEnabled = true;
    
    switch (loopType) {
        case LoopType.Fluid: {
            ocpsPolicyEnabled =
                isOcpsPolicyEnabled(OcpsPolicy.Loop, true, mailboxInfo) &&
                    isOcpsPolicyEnabled(OcpsPolicy.LoopEnabledForOutlook, true, mailboxInfo);
            break;
        }
        case LoopType.Poll: {
            ocpsPolicyEnabled = isOcpsPolicyEnabled(OcpsPolicy.LoopPolls, true, mailboxInfo);
            break;
        }
        case LoopType.VideoRecord:
            ocpsPolicyEnabled = isOcpsPolicyEnabled(OcpsPolicy.LoopVideoRecord, true, mailboxInfo);
            break;
        case LoopType.Planner:
            ocpsPolicyEnabled = isOcpsPolicyEnabled(OcpsPolicy.LoopPlanner, true, mailboxInfo);
            break;
        case LoopType.AnyLoop: {
            // Keep shared Loop infrastructure available; individual Loop types enforce their policies.
            break;
        }
    }
    
    return ocpsPolicyEnabled;
}
